// @flow
import Geolocation from 'common/domain/Geolocation';
import GeolocationReach from './GeolocationReach';

export interface GeoMapLayoutData {
  map: any;

  displayRegionKey: boolean;
  middleRegionAnchor: number | void;
  mapBounds: any;
}

class GeoMapLayout implements GeoMapLayoutData {

  map: any;
  displayRegionKey: boolean;
  middleRegionAnchor: number | void;
  mapBounds: any;

  constructor(data: GeoMapLayoutData) {
    this.map = data.map;
    this.middleRegionAnchor = data.middleRegionAnchor;
    this.displayRegionKey = data.displayRegionKey;
    this.mapBounds = data.mapBounds;
  }

  asRegionNames(reaches: GeolocationReach[]): { regionName: string, reach: number }[] {
    const regionNames = this.getRegionNames();
    return reaches
      .map(({ geolocation, reach }) => ({
        regionName: regionNames[geolocation.getUniqueId()] || geolocation.region,
        reach,
      }));
  }

  getRegionNames() {
    const regions: { [region: Geolocation]: string } = {};

    return this.map.features
      .map(feature => feature.properties)
      .reduce((acc, props) => {
        const regionName = props.name;

        const region = props.region || props.name;
        const state = props.state;
        const country = props.country;
        const geolocation = new Geolocation(region, state, country);

        acc[geolocation.getUniqueId()] = regionName;
        return regions;
      }, regions);
  }

  static parse(json: Object) {
    return new GeoMapLayout({
      map: json,
      displayRegionKey: true,
      middleRegionAnchor: undefined,
      mapBounds: json.mapBounds,
    });
  }
}

export default GeoMapLayout;



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/domain/GeoMapLayout.js